import { useMessageStore } from "../../stores/messageStore.js";

export default function PinnedMessagesPanel() {
  const messages = useMessageStore((state) => state.messages);
  const unpinMessage = useMessageStore((state) => state.unpinMessage);

  const pinnedMessages = messages.filter((m) => m.pinned);

  return (
    <div style={{ background: "rgb(var(--aethex-panel))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 8, padding: 16, maxHeight: 600, overflowY: "auto", minWidth: 320 }}>
      <h3 style={{ color: "rgb(var(--aethex-text))", marginTop: 0, marginBottom: 16, fontSize: 15, fontWeight: 700 }}>
        📌 Pinned Messages ({pinnedMessages.length})
      </h3>

      {pinnedMessages.length === 0 ? (
        <div style={{ padding: "40px 0", textAlign: "center" }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📌</div>
          <p style={{ color: "rgb(var(--aethex-dim))", fontSize: 13 }}>No pinned messages</p>
        </div>
      ) : (
        pinnedMessages.map((m) => (
          <div key={m.id} style={{ padding: 12, background: "rgb(var(--aethex-surface))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 8, marginBottom: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
              <strong style={{ color: "rgb(var(--aethex-primary))", fontSize: 13 }}>{m.author || m.senderName}</strong>
              <button
                onClick={() => unpinMessage(m.id)}
                style={{ background: "none", border: "none", color: "rgb(var(--aethex-dim))", cursor: "pointer", fontSize: 14, padding: "0 4px", lineHeight: 1 }}
                title="Unpin"
              >
                ✕
              </button>
            </div>
            <p style={{ color: "rgb(var(--aethex-muted))", margin: "0 0 4px 0", fontSize: 13, lineHeight: 1.5 }}>{m.content || m.text}</p>
            <p style={{ color: "rgb(var(--aethex-dim))", margin: 0, fontSize: 11 }}>{m.timestamp ? new Date(m.timestamp).toLocaleString() : ''}</p>
          </div>
        ))
      )}
    </div>
  );
}
